export default {
  namespaced: true,
  state: {
    isHandle: [],
    isCallArr: [],
    // mqtt
    alarmInfo: [],
    // 客服关爱  拨打电话
    callOut: [],
    // 服务商
    handleOder: [],
    // 设备拨打平台信息
    zgVideoObj: '',
    // 处理派单信息
    serviceInfo: {
      oldPerson: '',
      typeId: ''
    }
  },
  mutations: {
    // 处理添加
    set_is_handle (state, handle) {
      let flag = false
      let alarm = state.isHandle
      for (let i = 0; i < alarm.length; i++) {
        if (parseInt(handle.id) === parseInt(alarm[i].id)) {
          alarm[i] = handle
          flag = true
        }
      }
      if (!flag) {
        alarm.unshift(handle)
        state.isHandle = alarm
      }
      // state.isHandle.push(handle)
    },
    //  处理结束移除
    set_del_handle (state, alarmId) {
      for (let i = 0; i < state.isHandle.length; i++) {
        if (parseInt(alarmId) === parseInt(state.isHandle[i].id)) {
          state.isHandle.remove(state.isHandle[i])
        }
      }
    },
    // 呼叫添加
    set_is_call (state, call) {
      let flag = false
      let alarm = state.isCallArr
      for (let i = 0; i < alarm.length; i++) {
        if (parseInt(call.id) === parseInt(alarm[i].id)) {
          alarm[i] = call
          flag = true
        }
      }
      if (!flag) {
        alarm.unshift(call)
        state.isCallArr = alarm
      }
      // state.isHandle.push(handle)
    },
    //  呼叫结束移除
    set_del_call (state, callId) {
      for (let i = 0; i < state.isCallArr.length; i++) {
        if (parseInt(callId) === parseInt(state.isCallArr[i].id)) {
          state.isCallArr.remove(state.isCallArr[i])
        }
      }
    },
    // mqtt报警
    set_alarm_info (state, info) {
      // state.alarmInfo.push(info)
      let flag = false
      for (let i = 0; i < state.alarmInfo.length; i++) {
        if (parseInt(info.alarmid) === parseInt(state.alarmInfo[i].alarmid)) {
          state.alarmInfo[i] = info
          flag = true
        }
      }
      if (!flag) {
        state.alarmInfo.unshift(info)
      }
    },
    // mqtt处理报警移除
    set_del_alarm (state, id) {
      for (let i = 0; i < state.alarmInfo.length; i++) {
        if (id === state.alarmInfo[i].alarmid) {
          state.alarmInfo.remove(state.alarmInfo[i])
        }
      }
    },
    // 客服关爱添加
    set_call_out (state, call) {
      let flag = false
      let alarm = state.callOut
      for (let i = 0; i < alarm.length; i++) {
        if (parseInt(call.phone) === parseInt(alarm[i].phone)) {
          alarm[i] = call
          flag = true
        }
      }
      if (!flag) {
        alarm.unshift(call)
        state.callOut = alarm
      }
    },
    // 客服关爱移除
    set_del_call_out (state, phone) {
      for (let i = 0; i < state.callOut.length; i++) {
        if (phone === state.callOut[i].phone) {
          state.callOut.remove(state.callOut[i])
        }
      }
    },
    // 处理接单添加
    set_handle_order (state, handleOder) {
      let flag = false
      for (let i = 0; i < state.handleOder.length; i++) {
        if (parseInt(handleOder.id) === parseInt(state.handleOder[i].id)) {
          state.handleOder[i] = handleOder
          flag = true
        }
      }
      if (!flag) {
        state.handleOder.unshift(handleOder)
      }
    },
    // 处理接单移除
    set_del_handle_order (state, id) {
      for (let i = 0; i < state.handleOder.length; i++) {
        if (id === state.handleOder[i].id) {
          state.handleOder.remove(state.handleOder[i])
        }
      }
    },
    // 退出清空
    set_loginout_info  (state, info) {
      state.isHandle = info
      state.isCallArr = info
      state.alarmInfo = info
      state.callOut = info
      state.handleOder = info
      state.zgVideoObj = ''
    },
    set_zg (state, zgVideoObj) {
      state.zgVideoObj = zgVideoObj
    },
    set_handle_service (state, service) {
      state.serviceInfo = service
    }
  },
  actions: {
    update_is_handle ({commit}, handle) {
      commit('set_is_handle', handle)
    },
    update_del_handle ({commit}, alarmId) {
      commit('set_del_handle', alarmId)
    },
    update_is_call ({commit}, call) {
      commit('set_is_call', call)
    },
    update_del_call ({commit}, callId) {
      commit('set_del_call', callId)
    },
    update_alarm_info ({commit}, handle) {
      commit('set_alarm_info', handle)
    },
    update_del_alarm ({commit}, alarmId) {
      commit('set_del_alarm', alarmId)
    },
    update_call_out ({commit}, call) {
      commit('set_call_out', call)
    },
    update_del_call_out ({commit}, phone) {
      commit('set_del_call_out', phone)
    },
    update_handle_order ({commit}, handleOder) {
      commit('set_handle_order', handleOder)
    },
    update_del_handle_order ({commit}, id) {
      commit('set_del_handle_order', id)
    },
    update_loginout_info ({commit}, alarmId) {
      commit('set_loginout_info', alarmId)
    },
    update_zg_info ({commit}, obj) {
      commit('set_zg', obj)
    },
    update_handle_service ({commit}, obj) {
      commit('set_handle_service', obj)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/other.js